var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"snackbar-wrapper d-flex flex-column"},[_c('transition-group',{attrs:{"name":"slide"}},_vm._l((_vm.messages),function(message){return _c('v-alert',{key:message.id,attrs:{"type":message.type}},[_vm._v(" "+_vm._s(message.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }